// Open a `data:` URL in a new browser tab.
// Chrome and Safari block top-level navigation to `data:application/pdf;...`
// for security. We convert to a Blob and open the blob: URL instead.
export function openDataUrl(dataUrl) {
  if (!dataUrl || typeof dataUrl !== "string" || !dataUrl.startsWith("data:")) return;
  try {
    const commaIx = dataUrl.indexOf(",");
    const meta = dataUrl.slice(5, commaIx); // strip "data:"
    const isBase64 = meta.endsWith(";base64");
    const mime = (isBase64 ? meta.slice(0, -7) : meta) || "application/octet-stream";
    const payload = dataUrl.slice(commaIx + 1);
    let bytes;
    if (isBase64) {
      const bin = atob(payload);
      bytes = new Uint8Array(bin.length);
      for (let i = 0; i < bin.length; i++) bytes[i] = bin.charCodeAt(i);
    } else {
      bytes = new TextEncoder().encode(decodeURIComponent(payload));
    }
    const blob = new Blob([bytes], { type: mime });
    const url = URL.createObjectURL(blob);
    // _blank only — no noopener flag, because in Chrome that makes window.open
    // return null even on success, which previously triggered a same-tab fallback
    // that opened the file twice. The blob: URL is same-origin so no security concern.
    window.open(url, "_blank");
    // Revoke after the new tab has had plenty of time to load + the user has
    // had time to read the document. 10 minutes is enough for printing too.
    setTimeout(() => URL.revokeObjectURL(url), 10 * 60 * 1000);
  } catch (_) {
    // Last-resort fallback — open the raw data URL in a new tab.
    window.open(dataUrl, "_blank");
  }
}
